import { useSearchParams } from "react-router-dom";
import { PageHero } from "@/components/site/PageHero";
import { Reveal } from "@/components/site/Reveal";
import { EnquiryForm } from "@/components/site/EnquiryForm";
import { ENQUIRY_TYPES, BRAND_OPTIONS } from "@/config/site";
import { usePageMeta } from "@/hooks/usePageMeta";

const notes = {
  "Manufacturing & Supply Partnerships": "For manufacturers and suppliers interested in working with our consumer brands.",
  "Distribution & Retail Partnerships": "For distributors and retailers exploring trade and local commerce opportunities.",
  "Brand & Business Collaborations": "For organisations interested in co-development, collaborations or strategic conversations.",
  "Careers & Professional Opportunities": "For professionals who would like to be considered for future roles.",
};

export default function Partner() {
  usePageMeta("Partner With Us", "Start a business conversation with Suvirika Retail Pvt Ltd — manufacturing, supply, distribution, retail and brand partnerships.");
  const [params] = useSearchParams();
  const brand = BRAND_OPTIONS.includes(params.get("brand")) ? params.get("brand") : "";
  const type = ENQUIRY_TYPES.includes(params.get("type")) ? params.get("type") : "";
  return (
    <>
      <PageHero
        eyebrow="Partner With Us"
        lines={["Let's Build", <em key="i" className="italic font-light text-sky-ink">Meaningful</em>, "Business Partnerships."]}
        intro="We welcome conversations with manufacturers, distributors, retailers, suppliers, and potential business partners who share our interest in building sustainable consumer and commerce businesses."
        testId="partner-hero"
      />
      <section className="pb-24 md:pb-32">
        <div className="container-x grid gap-14 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <ul className="border-t hairline">
              {ENQUIRY_TYPES.map((t, i) => (
                <Reveal as="li" key={t} delay={i * 0.06} className="border-b hairline py-6">
                  <span className="font-mono-label text-xs text-[var(--ink-2)]">0{i + 1}</span>
                  <h2 className="mt-2 text-lg font-semibold">{t}</h2>
                  <p className="mt-1 text-[0.95rem] leading-relaxed text-[var(--ink-2)]">{notes[t]}</p>
                </Reveal>
              ))}
            </ul>
          </div>
          <Reveal delay={0.1} className="lg:col-span-8 border hairline bg-white p-6 md:p-12">
            <h2 className="font-display text-3xl">Start a Conversation</h2>
            <p className="mt-2 mb-10 text-[var(--ink-2)]">Fields marked * are required.</p>
            <EnquiryForm key={`${brand}-${type}`} defaultBrand={brand} defaultType={type} testId="partner-enquiry-form" />
          </Reveal>
        </div>
      </section>
    </>
  );
}
